import { Button, Input, Form, notification, Modal, Select, AutoComplete, Row, Col, DatePicker } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { addPropertyEnquiryFxn, getAllPropertyFxn } from '../action'
import { CountryCodeFlagJson } from '../../../components/_utils/countryUtil'
import PropertyTypeheadComponent from '../components/propertyTypehead'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'
import { getSingleUserFxn } from '../../xTravelTransfer/actions'
import { getUser } from '../../users/actions/user'

const { Option } = Select
const initialState = {
  fullName: '',
  email: '',
  phoneNumber: '',
  dialCode: undefined,
  countryName: '',
  cityName: '',
  propertyName: '',
  propertyId: '',
  duration: '',
  commission: '',
  moveInDate: '',
  budget: ''
}
const AddEnquiryModal = (props) => {
  const dispatch = useDispatch()
  const dateFormat = 'DD/MM/YYYY'
  let { visible, onClose, refreshList } = props
  let [state, setState] = useState(initialState)
  let [agentId, setAgentId] = useState('')
  let [userDetails, setUserDetails] = useState({})
  let [countryList, setCountryList] = useState([])
  const loadUserData = async () => {
    let userId = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : null
    setUserDetails(userId._id)
  }
  const events = {
    _updateState: (data) => {
      setState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    },

    getSingleUserData: (id) => {
      return new Promise(async (resolve) => {
        let resp = await dispatch(getUser(id))
        resolve(resp)
      })
    },
    handleSubmit: async () => {
      if (!state.propertyName) {
        notification.warning({ message: 'Please enter Property' })
        return
      }
      if (!state.fullName) {
        notification.warning({ message: 'Please enter Full Name.' })
        return
      }
      if (!state.email) {
        notification.warning({ message: 'Please enter Email.' })
        return
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailPattern.test(state.email)) {
        notification.warning({ message: 'Please enter a Valid Email.' })
        return
      }
      if (!state.dialCode) {
        notification.warning({ message: 'Please Select Country Code.' })
        return
      }
      if (!state.phoneNumber) {
        notification.warning({ message: 'Please enter Phone Number.' })
        return
      }

      if (!state.budget) {
        notification.warning({ message: 'Please enter Budget.' })
        return
      }
      if (!state.duration) {
        notification.warning({ message: 'Please enter Duration.' })
        return
      }
      if (!state.moveInDate) {
        notification.warning({ message: 'Please choose Move in Date.' })
        return
      }
      if (!state.commission) {
        notification.warning({ message: 'Please enter Commission.' })
        return
      }
      if (!agentId) {
        notification.warning({ message: 'Please choose Agent.' })
        return
      }
      state.userId = userDetails
      state.agentId = agentId
      let agentDoc = await events.getSingleUserData(agentId)
      state.agent = {
        agentId: agentId,
        name: agentDoc.name,
        companyName: agentDoc.companyName,
        email: agentDoc.email,
        mobile: agentDoc.mobile,
        countryCode: agentDoc.countryCode,
        countryName: agentDoc.countryName,
        stateName: agentDoc.stateName,
        cityName: agentDoc.cityName,
        address: agentDoc.address
      }
      let resp = await addPropertyEnquiryFxn({ ...state })

      if (resp && resp.success) {
        notification.success({ message: resp.message })
        refreshList()
        onClose()
      } else {
        notification.error({ message: resp.message })
      }

    }
  }
  useEffect(() => {
    loadUserData()
  }, [])
  useEffect(() => {
    setCountryList(CountryCodeFlagJson)
  }, [CountryCodeFlagJson])
  return (
    <Modal
      width={'35%'}
      title={`Add Enquiry`}
      visible={visible}
      onCancel={onClose}
      footer={null}>
      <Form>
        <Row gutter={16}>
          <Col span={24}>
            <InputBox title='Property Name *'>
              <PropertyTypeheadComponent
                key={state.propertyId}
                propertyId={state.propertyId}
                propertyName={state.propertyName}
                dispatch={dispatch}
                customStyle={''}
                onSelect={(id, name) => {
                  console.log(id, name)
                  events._updateState({ propertyId: id, propertyName: name })
                }}
              />
            </InputBox>
          </Col>
          <Col span={12}>
            <InputBox title='Full Name *'>
              <Input
                placeholder='Enter the Full Name '
                className='form-control'
                value={state.fullName}
                onChange={({ target }) => {
                  events._updateState({ fullName: target.value })
                }}
              />
            </InputBox>

          </Col>
          <Col span={12}>
            <InputBox title='Email *'>

              <Input
                type='email'
                placeholder='Enter Email'
                className='form-control'
                value={state.email}
                onChange={({ target }) => {
                  events._updateState({ email: target.value })
                }}
              />

            </InputBox>

          </Col>
          <Col span={12}>
            <InputBox title='Country Code *'>
              <Select
                showSearch={true}
                placeholder='Select Country Code'
                optionFilterProp={'label'}
                value={state.dialCode}
                filterOption={(input, options) => {
                  return options.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
                onChange={(e) => {
                  events._updateState({ dialCode: e })
                }}>
                {CountryCodeFlagJson.length && CountryCodeFlagJson.map((item) => {
                  return (
                    <Option value={item.countryCode}
                            label={`${item.dialCode} ${item.name}`}>
                      {item.emoji} {item.name} ({item.dialCode})
                    </Option>
                  )
                })}
              </Select>
            </InputBox>
          </Col>
          <Col span={12}>
            <InputBox title='Phone Number *'>
              <Input
                type='number'
                placeholder='Enter Phone Number'
                className='form-control'
                value={state.phoneNumber}
                onChange={({ target }) => {
                  events._updateState({ phoneNumber: target.value })
                }}
              />
            </InputBox>

          </Col>
          <Col span={12}>
            <InputBox title='Budget *'>
              <Input
                placeholder='Enter Budget'
                className='form-control'
                value={state.budget}
                onChange={({ target }) => {
                  events._updateState({ budget: target.value })
                }}
              />
            </InputBox>

          </Col>
          <Col span={12}>
            <InputBox title={'Move In Date *'}>
              <DatePicker
                format={dateFormat}
                className={'form-control'}
                value={state.moveInDate}
                onChange={(value) => {
                  events._updateState({ moveInDate: value })
                }}
              />
            </InputBox>

          </Col>

          <Col span={12}>
            <InputBox title='Duration *'>
              <Input
                placeholder='Duration'
                className='form-control'
                value={state.duration}
                onChange={({ target }) => {
                  events._updateState({ duration: target.value })
                }}
              />
            </InputBox>

          </Col>

          <Col span={12}>
            <InputBox title='Total Commission *'>
              <Input
                placeholder='Commission'
                className='form-control'
                value={state.commission}
                onChange={({ target }) => {
                  events._updateState({ commission: target.value })
                }}
              />
            </InputBox>

          </Col>
          <Col span={24}>
            <InputBox title='Agent *'>
              <AgentTypeheadComponent
                key={agentId}
                agentId={agentId}
                dispatch={dispatch}
                customStyle=''
                onSelect={item => setAgentId(item)}
                blockStatus={false}
              />
            </InputBox>

          </Col>
          <Col span={24}>
            <button className={'btn submit_btn mt10'} type='submit' onClick={events.handleSubmit}>SUBMIT
            </button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Form.create()(AddEnquiryModal)
